
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { Banner } from '@servicetitan/design-system';

const component = React.createElement(React.Fragment, null, React.createElement("h3", {
  className: "Headline Headline--small"
}, "Whom do I contact if I have questions or need integration support or if I want to provide feedback or make new feature/data inclusion requests?"), "\n", React.createElement("p", null, "For all queries please send an email to ", React.createElement("a", {
  className: "Link Link--blue",
  href: "mailto:integrations@servicetitan.com",
  target: "_blank",
  rel: "noopener noreferrer"
}, "integrations@servicetitan.com"), "."));

export default component;
